/**
 * HorseDay REST API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

export class FollowEventFlokkurRequest {
    'numer': number;
    'motsnumer': string;
    'flokkarNumers': Array<number>;
    'overried'?: boolean;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "numer",
            "baseName": "numer",
            "type": "number",
            "format": ""
        },
        {
            "name": "motsnumer",
            "baseName": "motsnumer",
            "type": "string",
            "format": ""
        },
        {
            "name": "flokkarNumers",
            "baseName": "flokkarNumers",
            "type": "Array<number>",
            "format": ""
        },
        {
            "name": "overried",
            "baseName": "overried",
            "type": "boolean",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return FollowEventFlokkurRequest.attributeTypeMap;
    }

    public constructor() {
    }
}

